import _extends from "@babel/runtime/helpers/extends";
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getOverrides, useClasses } from '../../../utils/overrides';
import RCMenu, { SubMenu, MenuItem } from 'rc-menu';
import { createUseStyles } from '../../../utils/styles';
import styles from './styles';
const useStyles = createUseStyles(styles, 'Menus');
const SIZES = {
  small: 140,
  medium: 220,
  large: 300
};
function Menus(_ref) {
  let {
    title,
    icon,
    items,
    classes: classesProp,
    overrides: overridesProp,
    className: classNameProp,
    classNameMenu,
    triggerAction = 'click',
    size = 'large'
  } = _ref;
  const popupSize = SIZES[size];
  const classes = useClasses(useStyles, classesProp, {
    popupSize
  });
  // Overrides
  const override = getOverrides(overridesProp, Menus.overrides);

  // Classes
  const rootClassName = classnames(classes.root, classNameProp);
  const menuClassName = classnames(classes.subMenu, classNameMenu);
  const menuProps = {
    mode: 'horizontal',
    className: classes.menu,
    triggerSubMenuAction: triggerAction,
    ...override['rc-menu']
  };
  const subMenuProps = {
    title: /*#__PURE__*/React.createElement(Fragment, null, icon && icon, title && title),
    popupClassName: menuClassName,
    ...override['rc-menu-sub-menu']
  };
  return /*#__PURE__*/React.createElement("div", _extends({
    className: rootClassName
  }, override.root), /*#__PURE__*/React.createElement(RCMenu, menuProps, /*#__PURE__*/React.createElement(SubMenu, _extends({
    key: "rc-menu-sub-menu"
  }, subMenuProps), items && items.map((item, id) => /*#__PURE__*/React.createElement(Fragment, null, !item.divider && /*#__PURE__*/React.createElement(MenuItem, {
    key: id,
    itemIcon: item.icon,
    onClick: item.onClick,
    className: item.infoItem ? classnames(classes.menuItem, item.className) : classnames(classes.menuItem, item.className, classes.clickable)
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.menuItemContent
  }, item.title, item.description)), item.divider && /*#__PURE__*/React.createElement("div", {
    className: classes.divider
  }))))));
}
Menus.overrides = ['root', 'rc-menu', 'rc-menu-sub-menu'];
process.env.NODE_ENV !== "production" ? Menus.propTypes = {
  title: PropTypes.any,
  icon: PropTypes.object,
  className: PropTypes.string,
  overrides: PropTypes.object,
  items: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.any,
    icon: PropTypes.object,
    infoItem: PropTypes.bool /** In order to know if an item is clickable or not */,
    onClick: PropTypes.func
  })),
  triggerAction: PropTypes.oneOf(['hover', 'click']),
  size: PropTypes.oneOf(['small', 'medium', 'large'])
} : void 0;
export default /*#__PURE__*/React.memo(Menus);